import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
import parserSlug from '@/utils/parserSlug'
import app from '../../main'

Vue.use(Vuex)

const state = {
  dashboard: [],
  customers: [],
  salesCustomer: [],
  kpis: [],
  prospection: [],
  paginationSalesCustomer: {
    currentPage: 1,
    perPage: 5,
    totalUsers: 0,
    totalPages: 0
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalUsers: 0,
    totalPages: 0
  },
  isModalSalesCustomerVisible: false,
  dashboardCatalog: {
    users: []
  }
}

const mutations = {
  SALES_CUSTOMER_SHOW (state, payload) {
    state.salesCustomer = payload.data
  },
  SALES_CUSTOMER_SHOW_PAGINATION (state, payload) {
    state.paginationSalesCustomer = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_DASHBOARD (state, payload) {
    state.dashboard = payload
  },
  SET_CUSTOMERS (state, payload) {
    state.customers = payload.data
  },
  SET_CUSTOMERS_PAGINATION (state, payload) {
    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_SELLERS (state, payload) {
    state.sellers = payload.data
  },
  SET_MODAL_SALES_CUSTOMER_VISIBLE (state, payload) {
    state.isModalSalesCustomerVisible = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.dashboardCatalog[object] = payload.data
  },
  SET_KPIS (state, payload) {
    state.kpis = payload
  },
  SET_PROSPECTION (state, payload) {
    state.prospection = payload
  }
}

const actions = {
  async loadSalesCustomer ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    commit('SALES_CUSTOMER_SHOW', { data: [] })
    try {
      const response = await Vue.axios.get(`dashboard/salescustomers?page=${payload.page}&customer_id[]=${payload.customer_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SALES_CUSTOMER_SHOW', response.data)
        commit('SALES_CUSTOMER_SHOW_PAGINATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadDashboard ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await Vue.axios.get('dashboard')
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DASHBOARD', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadKpis ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get('sales/kpis', { params: payload })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_KPIS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadProspects ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get('customers/prospects', { params: payload })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROSPECTION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadCustomers ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await Vue.axios.get(`dashboard/customers?page=${payload.page}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS', response.data)
        commit('SET_CUSTOMERS_PAGINATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSalesCustomers ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await Vue.axios.get(`dashboard/salescustomers/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_SALES_CUSTOMER_VISIBLE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalSalesCustomerVisible ({ commit }, payload) {
    commit('SET_MODAL_SALES_CUSTOMER_VISIBLE', payload)
  }
}

const getters = {
  dashboard: state => state.dashboard,
  customers: state => state.customers,
  sellers: state => state.sellers,
  salesCustomer: state => state.salesCustomer,
  dashboardCatalog: state => state.dashboardCatalog,
  pagination: state => state.pagination,
  paginationSalesCustomer: state => state.paginationSalesCustomer,
  isModalSalesCustomerVisible: state => state.isModalSalesCustomerVisible,
  kpis: state => state.kpis,
  prospection: state => state.prospection
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
